import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class SignupPageAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        signupPage: {},
        signupOpen: false,
        signupOver: false,
        showSeatMap: false,

        post: "",
        overPost: "",
        closedPost: "",
        fullPost: "",

        foodTicket: false,
        priceNoFood: null,
        priceWithFood: null,

        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getSignupPage = this.getSignupPage.bind(this);

      this.setEditMode = this.setEditMode.bind(this);
      this.handleChangeText = this.handleChangeText.bind(this);
      this.handleChangePriceFood = this.handleChangePriceFood.bind(this);
      this.handleChangePriceNoFood = this.handleChangePriceNoFood.bind(this);
      this.handleSavePrice = this.handleSavePrice.bind(this);
      this.handleSavePriceNoFood = this.handleSavePriceNoFood.bind(this);
      this.handleSaveText = this.handleSaveText.bind(this);
      this.saveSignupPage = this.saveSignupPage.bind(this);
      this.toggleCheckbox = this.toggleCheckbox.bind(this);
      this.setUpdatedBy = this.setUpdatedBy.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getSignupPage();

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      this.setState({
        signupPage: Object.assign({}, this.state.signupPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getSignupPage() {
      try {
        fetch("/api/pagedata/getSignupPage", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data && data.length > 0 && data[0]) {
              this.setState({ signupPage: data[0] });
              this.setState({ signupOpen: data[0].signupOpen });
              this.setState({ signupOver: data[0].signupOver });
              this.setState({ showSeatMap: data[0].showSeatMap });
              this.setState({ post: data[0].post });
              this.setState({ overPost: data[0].overPost });
              this.setState({ fullPost: data[0].fullPost });
              this.setState({ closedPost: data[0].closedPost });
              this.setState({ foodTicket: data[0].foodTicket });
              this.setState({ priceNoFood: data[0].priceNoFood });
              this.setState({ priceWithFood: data[0].priceWithFood });
              this.setState({ updated: Date().slice(16, 24) });
            } else {
              // Handle empty database case with default values
              const defaultSignupPage = {
                signupOpen: false,
                signupOver: false,
                showSeatMap: false,
                post: "Signup information will be available soon.",
                overPost: "Signup is now closed.",
                fullPost: "The event is full.",
                closedPost: "Signup is currently closed.",
                foodTicket: false,
                priceNoFood: 300,
                priceWithFood: 400
              };
              this.setState({
                signupPage: defaultSignupPage,
                signupOpen: defaultSignupPage.signupOpen,
                signupOver: defaultSignupPage.signupOver,
                showSeatMap: defaultSignupPage.showSeatMap,
                post: defaultSignupPage.post,
                overPost: defaultSignupPage.overPost,
                fullPost: defaultSignupPage.fullPost,
                closedPost: defaultSignupPage.closedPost,
                foodTicket: defaultSignupPage.foodTicket,
                priceNoFood: defaultSignupPage.priceNoFood,
                priceWithFood: defaultSignupPage.priceWithFood,
                updated: Date().slice(16, 24)
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }

    async setEditMode() {
      if (this.state.editMode === false) {
        this.setState({ editMode: true });
      } else {
        this.setState({ editMode: false });
      }
      await this.getSignupPage();
    }

    async setUpdatedBy() {
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      await this.setState({
        signupPage: Object.assign({}, this.state.signupPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    async saveSignupPage() {
      await this.setUpdatedBy();
      try {
        await authenticatedFetch("/api/admin/updateSignupPage", {
          method: "PUT",
          body: JSON.stringify(this.state.signupPage),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.setState({ editMode: false });
        window.scrollTo(0, 0);
      }
    }

    toggleCheckbox(event) {
      if (event.target.name === "signupOpen") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            signupOpen: event.target.checked
          })
        });
      } else if (event.target.name === "signupOver") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            signupOver: event.target.checked
          })
        });
      } else if (event.target.name === "foodTicket") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            foodTicket: event.target.checked
          })
        });
      } else if (event.target.name === "showSeatMap") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            showSeatMap: event.target.checked
          })
        });
      }
    }

    handleChangePriceFood(event) {
      let value = event.target.value.trimLeft();
      value = value.trimRight();
      value = parseInt(value);
      console.log(event);
      console.log(value);
        this.setState({
          priceWithFood: value
        });
    }

    handleChangePriceNoFood(event) {
      let value = event.target.value.trimLeft();
      value = value.trimRight();
      value = parseInt(value);
      console.log(event);
      console.log(value);
        this.setState({
          priceNoFood: value
        });
    }

    async handleSavePrice(event) {
      event.preventDefault();
      if (this.state.priceWithFood !== null) {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            priceWithFood: this.state.priceWithFood
          })
        });
      }
    }

    async handleSavePriceNoFood(event) {
      event.preventDefault();
      if (this.state.priceNoFood !== null) {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            priceNoFood: this.state.priceNoFood
          })
        });
      }
    }


    handleChangeText(event) {
      if (event.target.name === "mainPost") {
        this.setState({
          post: event.target.value,
          signupPage: Object.assign({}, this.state.signupPage, {
            post: event.target.value
          })
        });
      } else if (event.target.name === "overPost") {
        this.setState({
          overPost: event.target.value,
          signupPage: Object.assign({}, this.state.signupPage, {
            overPost: event.target.value
          })
        });
      } else if (event.target.name === "fullPost") {
        this.setState({
          fullPost: event.target.value,
          signupPage: Object.assign({}, this.state.signupPage, {
            fullPost: event.target.value
          })
        });
      } else if (event.target.name === "closedPost") {
        this.setState({
          closedPost: event.target.value,
          signupPage: Object.assign({}, this.state.signupPage, {
            closedPost: event.target.value
          })
        });
      }
    }

    handleSaveText(event) {
      event.preventDefault();
      if (event.target.name === "mainPostButton") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            post: this.state.post
          })
        });
      } else if (event.target.name === "closedPostButton") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            closedPost: this.state.closedPost
          })
        });
      } else if (event.target.name === "fullPostButton") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            fullPost: this.state.fullPost
          })
        });
      } else if (event.target.name === "overPostButton") {
        this.setState({
          signupPage: Object.assign({}, this.state.signupPage, {
            overPost: this.state.overPost
          })
        });
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      return (
        <div className="SignupList">
          <h1>Påmeldingssiden</h1>
          <button
            className={
              "btn btno edit  " +
              (this.state.editMode ? "btn-info" : "btn-danger")
            }
            onClick={this.setEditMode}
          >
            {this.state.editMode ? "Lås" : "Rediger"}
          </button>
          <button
            className="btn btno btn-success edit  "
            onClick={() => this.getSignupPage()}
          >
            Refresh
          </button>

          {this.state.editMode && (
            <button
              className="btn btno btn-primary edit"
              onClick={this.saveSignupPage}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              Lagre endringer
            </button>
          )}

          <hr />
          <h1 className="center">Påmelding</h1>

          <form className="dateFieldsContainer center">
            <div>
              <div className="center">
                <h6>Påmelding åpen?</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="signupOpen"
                  defaultChecked={this.state.signupPage.signupOpen}
                  onClick={this.toggleCheckbox}
                />
              </div>
              <hr />
              <div className="center">
                <h6>Påmelding over?</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="signupOver"
                  defaultChecked={this.state.signupPage.signupOver}
                  onClick={this.toggleCheckbox}
                />
              </div>
              <hr />
              <div className="center">
                <h6>Vis plasskart?</h6>
                <input
                  disabled={!this.state.editMode}
                  type="checkbox"
                  name="showSeatMap"
                  defaultChecked={this.state.signupPage.showSeatMap}
                  onClick={this.toggleCheckbox}
                />
              </div>
              <hr />
            </div>
          </form>

          <div className="dateFieldsContainer center">
            <h6>Matbillett</h6>
            <input
              disabled={!this.state.editMode}
              type="checkbox"
              name="foodTicket"
              defaultChecked={this.state.signupPage.foodTicket}
              onClick={this.toggleCheckbox}
            />
          </div>
            <div className="dateFieldsContainer center">
              <h6>Pris uten mat</h6>
              <input
                disabled={!this.state.editMode}
                className="dateFields"
                name="noFood"
                defaultValue={this.state.signupPage.priceNoFood}
                onChange={this.handleChangePriceNoFood}
              />
                            <button
                disabled={!this.state.editMode}
                className="btn btno btn-success edit  "
                onClick={this.handleSavePriceNoFood}
              >
                Endre pris
              </button>
              <br/>
              <h6>Pris med mat</h6>
              <input
                disabled={!this.state.editMode}
                className="dateFields"
                name="withFood"
                defaultValue={this.state.signupPage.priceWithFood}
                onChange={this.handleChangePriceFood}
              />
              <button
                disabled={!this.state.editMode}
                className="btn btno btn-success edit  "
                onClick={this.handleSavePrice}
              >
                Endre pris
              </button>
            </div>
          <hr />
          {this.state.editMode ? (
            <div>
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Påmelding åpen post</h5>
                  <div className="card">
                    <textarea
                      name="mainPost"
                      value={this.state.post}
                      onChange={this.handleChangeText}
                      rows="8"
                      style={{ width: "100%", minHeight: "200px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Påmelding åpen post</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{ __html: this.state.post }}
                    style={{ minHeight: "200px" }}
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Påmelding stengt post</h5>
                  <div className="card">
                    <textarea
                      name="closedPost"
                      value={this.state.closedPost}
                      onChange={this.handleChangeText}
                      rows="8"
                      style={{ width: "100%", minHeight: "200px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Påmelding stengt post</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{ __html: this.state.closedPost }}
                    style={{ minHeight: "200px" }}
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Påmelding full post</h5>
                  <div className="card">
                    <textarea
                      name="fullPost"
                      value={this.state.fullPost}
                      onChange={this.handleChangeText}
                      rows="8"
                      style={{ width: "100%", minHeight: "200px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Påmelding full post</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{ __html: this.state.fullPost }}
                    style={{ minHeight: "200px" }}
                  />
                </div>
              </div>

              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Påmelding over post</h5>
                  <div className="card">
                    <textarea
                      name="overPost"
                      value={this.state.overPost}
                      onChange={this.handleChangeText}
                      rows="8"
                      style={{ width: "100%", minHeight: "200px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Påmelding over post</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{ __html: this.state.overPost }}
                    style={{ minHeight: "200px" }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <div>
                <h5 className="center">Påmelding åpen post:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{ __html: this.state.signupPage.post }}
                />
                <hr />
              </div>
              <div>
                <h5 className="center">Påmelding stengt post:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.signupPage.closedPost
                  }}
                />
                <hr />
              </div>
              <div>
                <h5 className="center">Påmelding full post:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.signupPage.fullPost
                  }}
                />
                <hr />
              </div>
              <div>
                <h5 className="center">Påmelding over post:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.signupPage.overPost
                  }}
                />
                <hr />
              </div>
            </div>
          )}

          <hr />
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/SignupPageAdmin.js